import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { Paper } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useTabs } from "../../../../../context/TabContext";
import CustomDataGrid from "../../../../../reusable-components/datagrid/CustomDataGrid"
import { PREVIOUS_RENTALS } from '../../../../../reusable-components/datagrid/rentalColumns';
import ManagerChipsWrapper from "../../../../../reusable-components/datagrid/ManagerChipsWrapper";
import { getUserRentals } from "../../../../../api/rentals";

UserRentalsTab.propTypes = {
  user: PropTypes.object,
};
export default function UserRentalsTab({ user }) {

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { addNewTabAndNavigate } = useTabs();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getUserRentals(user.email);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      enqueueSnackbar('Error fetching user orders data', { variant: 'error' });
      setIsLoading(false);
    }
  };
  
    useEffect(() => {
      if(user?.email) fetchData();
    }, [user]);

    useEffect(() => {
      if(!user?.email) setIsLoading(true);
    }, [])
  
    
    const manager = ManagerChipsWrapper(null, 'Rentals');
  
    const rowClick = (row) => {
      const filter = row.rejectedOn || row. closedOn ? 'previous' :
                     row.approvedOn && !row.rejectedOn && !row.closedOn ? 'current' :
                     'pending';
      addNewTabAndNavigate(`/dashboard/rentals/rental-order/${row.orderId}/${filter}?back=userRentals&userId=${user.id}`);
    };
    
    return (
      <Paper>
        <CustomDataGrid
          gridId="user-rentals"
          boxSX={{ width: '100%', height: 'calc(100vh - 260px)' }}
          data={data}
          getRowId={(row) => row.orderId}
          gridColumns={[...PREVIOUS_RENTALS, manager]}
          isLoading={isLoading}
          sort={[{ field: 'name', sort: 'asc' }]}
          onRowClick={(params, e) => {
            if (e.openTicket) return;
            const selection = window.getSelection().toString();
            if (selection.length > 0) return;
            if (e.deleteChip || e.addChip) return;
            rowClick(params.row);
          }}
        />
      </Paper>
    )
}